<template>
  <div class="flex flex-col gap-2 mb-2 h-max">
    <span class="text-start px-2 rounded"> כדי להתחבר צריך מספר מסוף, מזהה API ופרטי אימות. התחברו לחשבון Hyp שברשותכם, והיכנסו להגדרות.</span>
    <div class="px-2">
      <span class="font-light rounded text-right"> 1. העתיקו את מספר המסוף, Api Key ואת רשימת פרמטרי האימות כפי שמופעים באתר.</span>
      <info-button>
        <img src="../../../../../assets/img/admin/hyp-integration.png" class="w-full" />
      </info-button>
    </div>
    <UseClipboard v-slot="{ copy }" source="https://time-it.co.il/p/success">
                <span class="font-light px-2 rounded text-right"
                      @click="copy();  toast.success('קישור הועתק');"> 2. עדכנו את כתובת ההצלחה לכתובת https://time-it.co.il/p/success</span>
    </UseClipboard>
    <UseClipboard v-slot="{ copy }" source="https://time-it.co.il/p/failure">
                <span class="font-light px-2 rounded text-right"
                      @click="copy();  toast.success('קישור הועתק');"> 3. עדכנו את כתובת הכישלון לכתובת https://time-it.co.il/p/failure</span>
    </UseClipboard>

    <div class="w-full mt-6">
      <Button
        label="הבא"
        class="w-full"
        style="display: flex; flex-grow: 1"
        @click="$emit('next')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">

import { UseClipboard } from '@vueuse/components';
import { useToast } from 'vue-toastification';

defineEmits(['next']);

const toast = useToast();

</script>

<style scoped lang="scss">

</style>
